import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { agentProductionTerms } from '../../../constants'
import AgentsTableControls from './AgentsTableControls'
import { growthAnalysisTooltips, tabModes } from '../../constants/agentProductionConstants'
import { getClassNameSuppressHeaders } from '../../helpers/schemaTableHelpers'
import { getIsPeriodLast12Months } from '../helpers/growthAnalysisHelpers'
import Table from '../../../common/components/table/agGrid/Table'
import { tableViews } from '../../../common/components/table/agGrid/tableViews';
import AgentsFloatingActionBar from '../common/AgentsFloatingActionBar';
import { useAgentTableDownload } from '../../hooks/agentTableDownload';
import { views } from '../../constants/savedAgents';

const GrowthAnalysis = ({
    agentData,
    additionalTableHeadersLtm,
    additionalTableHeadersYtd,
    growthAnalysisPeriod,
    setGrowthAnalysisPeriod,
    ltmColumns,
    ytdColumns,
    setColumnsLtm,
    setColumnsYtd,
    currentSearchDates,
    state,
    setState,
    isActive,
}) => {

    const isPeriodLast12Months = getIsPeriodLast12Months(growthAnalysisPeriod);
    const columns = isPeriodLast12Months ? ltmColumns : ytdColumns;

    const {
        gridRef,
        selectedCount,
        showAddToListModal,
        setShowAddToListModal,
        handleDismiss,
        handleDownloadClick,
    } = useAgentTableDownload({ state, setState, selectedView: views.growthAnalysis });

    useEffect(() => {
        setGrowthAnalysisPeriod(agentProductionTerms.last12Months)
    }, [agentData])

    const setColumnsLocal = cols => {
        if (isPeriodLast12Months) {
            setColumnsLtm(cols)
        } else {
            setColumnsYtd(cols)
        }
    }

    const customSettings = {
        isPeriodLast12Months,
        currentSearchDates
    }

    const classNameContainerLtm = getClassNameSuppressHeaders(additionalTableHeadersLtm)
    const classNameContainerYtd = getClassNameSuppressHeaders(additionalTableHeadersYtd)

    return (
        <>
            <AgentsTableControls
                isTableSelected={true}
                tabMode={tabModes.GROWTH_ANALYSIS}
                columns={columns}
                setColumns={setColumnsLocal}
                hasShowHideColumnsButton={true}
                hasTableChartToggle={false}
                growthAnalysisPeriod={growthAnalysisPeriod}
                setGrowthAnalysisPeriod={setGrowthAnalysisPeriod}
                popoverClassName={'growth-analysis'}
                customSettings={customSettings}
            />
            {isPeriodLast12Months ? (
                <div className={classNameContainerLtm}>
                <Table
                    gridRef={gridRef}
                    tableView={tableViews.growthAnalysisLtm}
                    rowData={agentData}
                    columns={columns}
                    additionalTableHeaders={additionalTableHeadersLtm}
                    tableTitleWithTooltips={growthAnalysisTooltips}
                    rowSelection={'multiple'}
                    suppressRowClickSelection={true}
                    rowMultiSelectWithClick={true}
                />
                </div>
            ) : (
                <div className={classNameContainerYtd}>
                    <Table
                        gridRef={gridRef}
                        tableView={tableViews.growthAnalysisYtd}
                        rowData={agentData}
                        columns={columns}
                        additionalTableHeaders={additionalTableHeadersYtd}
                        tableTitleWithTooltips={growthAnalysisTooltips}
                        rowSelection={'multiple'}
                        suppressRowClickSelection={true}
                        rowMultiSelectWithClick={true}
                    />
                </div>
            )}
            {isActive && (
                <AgentsFloatingActionBar
                    selectedCount={selectedCount}
                    showAddToListModal={showAddToListModal}
                    setShowAddToListModal={setShowAddToListModal}
                    onDismiss={handleDismiss}
                    onDownloadClick={handleDownloadClick}
                />
            )}
        </>
    )
}

GrowthAnalysis.propTypes = {
    agentData: PropTypes.arrayOf(PropTypes.object),
    additionalTableHeadersLtm: PropTypes.arrayOf(PropTypes.object),
    additionalTableHeadersYtd: PropTypes.arrayOf(PropTypes.object),
    growthAnalysisPeriod: PropTypes.string,
    setGrowthAnalysisPeriod: PropTypes.func,
    ltmColumns: PropTypes.arrayOf(PropTypes.object),
    ytdColumns: PropTypes.arrayOf(PropTypes.object),
    setColumnsLtm: PropTypes.func,
    setColumnsYtd: PropTypes.func,
    currentSearchDates: PropTypes.object,
    state: PropTypes.object,
    setState: PropTypes.func,
    isActive: PropTypes.bool,
};

export default GrowthAnalysis;
